export const Storage = {
  fetch: key => {
    const value = localStorage.getItem(key)

    if (value) {
      return JSON.parse(value)
    } else {
      return null
    }
  },
  remove: key => localStorage.removeItem(key),
  store: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
}
